import { StyleSheet, Platform } from 'react-native'
import { darkTheme } from '../../src/theme/themes'

/** Shared with ContactForm.tsx for placeholders and icons (dark panel on /contact). */
export const contactFormUiTokens = {
  placeholderTextColor: darkTheme.gray[500],
  successIconColor: darkTheme.secondary,
  submitIconColor: darkTheme.white,
}

export const contactFormStyles = StyleSheet.create({
  formContainer: {
    maxWidth: 600,
    width: '100%',
    alignSelf: 'center',
    gap: 24,
  },
  formContainerPhone: {
    gap: 20,
  },
  inputGroup: {
    gap: 10,
  },
  inputGroupPhone: {
    gap: 8,
  },
  label: {
    fontSize: 16,
    fontWeight: '600',
    color: darkTheme.white,
  },
  labelPhone: {
    fontSize: 15,
  },
  input: {
    backgroundColor: darkTheme.background.cardElevated,
    borderWidth: 1,
    borderColor: darkTheme.gray[300],
    borderRadius: 12,
    paddingHorizontal: 20,
    paddingVertical: 16,
    fontSize: 16,
    color: darkTheme.black,
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      ':focus': {
        borderColor: darkTheme.primary,
        borderWidth: 2,
      },
    }),
  },
  inputPhone: {
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 15,
  },
  inputError: {
    borderColor: darkTheme.error,
    borderWidth: 1.5,
  },
  errorContainer: {
    marginTop: 8,
  },
  errorContainerPhone: {
    marginTop: 6,
  },
  errorText: {
    fontSize: 14,
    color: darkTheme.error,
    fontWeight: '500',
  },
  errorTextPhone: {
    fontSize: 13,
  },
  characterCount: {
    fontSize: 13,
    color: darkTheme.gray[500],
    textAlign: 'right',
    marginTop: 6,
  },
  characterCountPhone: {
    fontSize: 12,
    marginTop: 4,
  },
  textArea: {
    minHeight: 150,
    paddingTop: 16,
    ...(Platform.OS === 'web' && {
      resize: 'vertical',
    }),
  },
  textAreaPhone: {
    minHeight: 120,
    paddingTop: 12,
  },
  submitButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: darkTheme.primary,
    borderRadius: 12,
    paddingVertical: 18,
    paddingHorizontal: 32,
    gap: 8,
    marginTop: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 2,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        backgroundColor: darkTheme.primaryDark,
        transform: 'translateY(-1px)',
        shadowOpacity: 0.35,
        shadowRadius: 6,
      },
      ':active': {
        transform: 'translateY(0)',
      },
    }),
  },
  submitButtonPhone: {
    borderRadius: 8,
    paddingVertical: 14,
    paddingHorizontal: 24,
    marginTop: 8,
  },
  submitButtonDisabled: {
    opacity: 0.6,
    ...(Platform.OS === 'web' ? {
      cursor: 'not-allowed',
      ':hover': {
        backgroundColor: darkTheme.primary,
        transform: 'none',
      },
    } as never : {}),
  },
  submitButtonIcon: {
    marginRight: 4,
  },
  submitButtonLoader: {
    marginRight: 8,
  },
  submitButtonText: {
    fontSize: 18,
    fontWeight: '700',
    color: darkTheme.white,
  },
  submitButtonTextPhone: {
    fontSize: 16,
  },
  successContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 60,
    gap: 20,
  },
  successContainerPhone: {
    paddingVertical: 40,
    gap: 16,
  },
  successText: {
    fontSize: 18,
    fontWeight: '600',
    color: darkTheme.secondary,
    textAlign: 'center',
  },
  successTextPhone: {
    fontSize: 16,
    paddingHorizontal: 20,
  },
})

